























import { listFactory } from '@/main/pages';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			parameters: 'null' as string,
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		async filterClick() {
			let dateFrom = this.DateFrom;			
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					DateFrom: dateFrom,
					DateTo: this.DateTo,
					ColumnSequence: columnsSeq.join(','),
					BrandCode: this.BrandCode,
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
		GetParameters(WorkshopIds : any, fromDate : any, toDate : any, BrandCode: any) {
			this.parameters = '';
			const dateFromStr = fromDate ? new Date(fromDate).toISOString() : '';
			const dateToStr = toDate ? new Date(toDate).toISOString() : '';
			this.parameters = `DateFrom=${dateFromStr}&DateTo=${dateToStr}`;
			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((workshop: any) => {
					this.parameters = this.parameters.concat(`&workshopIds=${workshop}`);
				});
			}
			if (BrandCode.length > 0) {
				BrandCode.forEach((code: any) => {
					this.parameters = this.parameters.concat(`&BrandCode=${code}`);
				});
			}
			return this.parameters;
		},
		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.WorkshopIds, this.DateFrom, this.DateTo, this.BrandCode);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetDailyPerformanceReport(urlParameters, columnsSeq);
				}
			} finally {
				this.endLoading();
			}
		},
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length != 0) element[0].classList.remove('d-flex');
	},
});
